import dynamic from "next/dynamic";

// LINEUP CONTENT (Phoenix modules)
export const LineupContent2Up = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/2-up/LineupContent2Up"
        ),
    { ssr: true }
);

export const LineupContent3Up = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/3-up/LineupContent3Up"
        ),
    { ssr: true }
);

export const LineupContent4Up = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/4-up/LineupContent4Up"
        ),
    { ssr: true }
);

export const LineupContent4UpVideo = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/4-up-video/LineupContent4UpVideo"
        ),
    { ssr: true }
);

export const LineupContent4UpPodcast = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/4-up-podcast/LineupContent4UpPodcast"
        ),
    { ssr: true }
);

export const LineupContentBasic = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/basic/LineupContentBasic"
        ),
    { ssr: true }
);

export const LineupContentBreakingAdaptiveNested = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/breaking-adaptive-nested/LineupContentBreakingAdaptiveNested"
        ),
    { ssr: true }
);

export const LineupContentBreakingSimple = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/breaking-simple/LineupContentBreakingSimple"
        ),
    { ssr: true }
);

export const LineupContentCarouselBasic = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/carousel-basic/LineupContentCarouselBasic"
        ),
    { ssr: true }
);

export const LineupContentCarouselMagazine = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/carousel-magazine/LineupContentCarouselMagazine"
        ),
    { ssr: true }
);

export const LineupContentCarousel3Up = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/carousel-3-up/LineupContentCarousel3Up"
        ),
    { ssr: true }
);

export const LineupContentCarousel3UpVideo = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/carousel-3-up-video/LineupContentCarousel3UpVideo"
        ),
    { ssr: true }
);

export const LineupContentFeatureLede = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/feature-lede/LineupContentFeatureLede"
        ),
    { ssr: true }
);

export const LineupContentFeatureLedeWeekend = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/feature-lede-weekend/LineupContentFeatureLedeWeekend"
        ),
    { ssr: true }
);

export const LineupContentHeadshots = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/headshots/LineupContentHeadshots"
        ),
    { ssr: true }
);

export const LineupContentLede = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/lede/LineupContentLede"
        ),
    { ssr: true }
);

export const LineupContentMagazine = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/magazine/LineupContentMagazine"
        ),
    { ssr: true }
);

export const LineupContentOpinion = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/opinion/LineupContentOpinion"
        ),
    { ssr: true }
);

export const LineupContentTopic = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/topic/LineupContentTopic"
        ),
    { ssr: true }
);

export const LineupContentTwoColLede = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/two-col-lede/LineupContentTwoColLede"
        ),
    { ssr: true }
);

// CAROUSEL
export const Carousel = dynamic(
    () => import("~components/modules/carousel/composer/Carousel"),
    {
        ssr: true,
    }
);

export const CarouselBwCovers = dynamic(
    () =>
        import(
            "~components/modules/carousel/variants/bw-covers/CarouselBwCovers"
        ),
    { ssr: true }
);
export const CarouselDefault = dynamic(
    () =>
        import("~components/modules/carousel/variants/default/CarouselDefault"),
    { ssr: true }
);
// GRID
export const GridImageless = dynamic(
    () => import("~components/modules/grid/variants/imageless/GridImageless"),
    { ssr: true }
);

// HERO
export const HeroBusinessweekWhite = dynamic(
    () =>
        import(
            "~components/modules/hero/variants/businessweek-white/HeroBusinessweekWhite"
        ),
    { ssr: true }
);

export const HeroHfsTwoFlex = dynamic(
    () =>
        import("~components/modules/hero/variants/hfs-two-flex/HeroHfsTwoFlex"),
    { ssr: true }
);

// LINKS
export const LinksDefault = dynamic(
    () => import("~components/modules/links/variants/default/LinksDefault"),
    { ssr: true }
);

// POSTER
export const PosterDefault = dynamic(
    () => import("~components/modules/poster/variants/default/PosterDefault"),
    { ssr: true }
);

// SANDBOX
export const SandboxDefault = dynamic(
    () => import("~components/modules/sandbox/variants/default/SandboxDefault"),
    { ssr: true }
);

// SECTION FRONT HEADER
export const SectionFrontHeaderDefault = dynamic(
    () =>
        import(
            "~components/modules/section-front-header/variants/default/SectionFrontHeaderDefault"
        ),
    { ssr: true }
);

export const SectionFrontHeaderBrand = dynamic(
    () =>
        import(
            "~components/modules/section-front-header/variants/brand/SectionFrontHeaderBrand"
        ),
    { ssr: true }
);

export const SectionFrontHeaderPillar = dynamic(
    () =>
        import(
            "~components/modules/section-front-header/variants/pillar/SectionFrontHeaderPillar"
        ),
    { ssr: true }
);

export const SectionFrontHeaderImage = dynamic(
    () =>
        import(
            "~components/modules/section-front-header/variants/image/SectionFrontHeaderImage"
        ),
    { ssr: true }
);

// SINGLE STORY
export const SingleStoryAdaptiveHfsWithoutEmbed = dynamic(
    () =>
        import(
            "~components/modules/single-story/variants/adaptive-hfs-without-embed/SingleStoryAdaptiveHfsWithoutEmbed"
        ),
    { ssr: true }
);
export const SingleStoryAdaptiveHfs = dynamic(
    () =>
        import(
            "~components/modules/single-story/variants/adaptive-hfs/SingleStoryAdaptiveHfs"
        ),
    { ssr: true }
);
export const SingleStoryImageLeft = dynamic(
    () =>
        import(
            "~components/modules/single-story/variants/image-left/SingleStoryImageLeft"
        ),
    { ssr: true }
);
export const SingleStoryBusinessweekImageLeft = dynamic(
    () =>
        import(
            "~components/modules/single-story/variants/businessweek-image-left/SingleStoryBusinessweekImageLeft"
        ),
    { ssr: true }
);
export const SingleStoryBwPursuitsImageLeft = dynamic(
    () =>
        import(
            "~components/modules/single-story/variants/bw-pursuits-image-left/SingleStoryBwPursuitsImageLeft"
        ),
    { ssr: true }
);
export const SingleStoryImageRight = dynamic(
    () =>
        import(
            "~components/modules/single-story/variants/image-right/SingleStoryImageRight"
        ),
    { ssr: true }
);
export const SingleStoryBusinessweekImageRight = dynamic(
    () =>
        import(
            "~components/modules/single-story/variants/businessweek-image-right/SingleStoryBusinessweekImageRight"
        ),
    { ssr: true }
);
export const SingleStoryPremiumHfs = dynamic(
    () =>
        import(
            "~components/modules/single-story/variants/premium-hfs/SingleStoryPremiumHfs"
        ),
    { ssr: true }
);
export const SingleStoryPremiumHfsOpinion = dynamic(
    () =>
        import(
            "~components/modules/single-story/variants/premium-hfs-opinion/SingleStoryPremiumHfsOpinion"
        ),
    { ssr: true }
);
export const SingleStoryDefault = dynamic(
    () =>
        import(
            "~components/modules/single-story/variants/default/SingleStoryDefault"
        ),
    { ssr: true }
);
export const SingleStoryHomepageLede = dynamic(
    () =>
        import(
            "~components/modules/single-story/variants/homepage-lede/SingleStoryHomepageLede"
        ),
    { ssr: true }
);
export const SingleStoryHomepageLedeWithDek = dynamic(
    () =>
        import(
            "~components/modules/single-story/variants/homepage-lede-with-dek/SingleStoryHomepageLedeWithDek"
        ),
    { ssr: true }
);
export const SingleStoryUkDefault = dynamic(
    () =>
        import(
            "~components/modules/single-story/variants/uk-default/SingleStoryUkDefault"
        ),
    { ssr: true }
);

export const SingleStoryCitylabVertical = dynamic(
    () =>
        import(
            "~components/modules/single-story/variants/citylab-vertical/SingleStoryCitylabVertical"
        ),
    { ssr: true }
);

export const SingleStoryCitylabImageRight = dynamic(
    () =>
        import(
            "~components/modules/single-story/variants/citylab-image-right/SingleStoryCitylabImageRight"
        ),
    { ssr: true }
);

export const SingleStoryImagelessHeadlineStory = dynamic(
    () =>
        import(
            "~components/modules/single-story/variants/imageless-headline-story/SingleStoryImagelessHeadlineStory"
        ),
    { ssr: true }
);

// SOCIAL BUTTONS
export const SocialButtonsDefault = dynamic(
    () =>
        import(
            "~components/modules/social-buttons/variants/default/SocialButtonsDefault"
        ),
    { ssr: true }
);

// STORY LIST
export const StoryListBullets = dynamic(
    () =>
        import(
            "~components/modules/story-list/variants/bullets/StoryListBullets"
        ),
    { ssr: true }
);
export const StoryListDarkRail = dynamic(
    () =>
        import(
            "~components/modules/story-list/variants/dark-rail/StoryListDarkRail"
        ),
    { ssr: true }
);
export const StoryListDefault = dynamic(
    () =>
        import(
            "~components/modules/story-list/variants/default/StoryListDefault"
        ),
    { ssr: true }
);
export const StoryListSimple = dynamic(
    () =>
        import(
            "~components/modules/story-list/variants/simple/StoryListSimple"
        ),
    { ssr: true }
);
export const StoryListLarge = dynamic(
    () =>
        import("~components/modules/story-list/variants/large/StoryListLarge"),
    { ssr: true }
);
export const StoryListPagination = dynamic(
    () =>
        import(
            "~components/modules/story-list/variants/pagination/StoryListPagination"
        ),
    { ssr: true }
);
export const StoryListTrending = dynamic(
    () =>
        import(
            "~components/modules/story-list/variants/trending/StoryListTrending"
        ),
    { ssr: true }
);

export const StoryListLatest = dynamic(
    () =>
        import(
            "~components/modules/story-list/variants/latest/StoryListLatest"
        ),
    { ssr: true }
);

export const StoryListAuthorPage = dynamic(
    () =>
        import(
            "~components/modules/story-list/variants/author-page/StoryListAuthorPage"
        ),
    { ssr: true }
);

// STORY PACKAGE
export const StoryPackage3UpDeks = dynamic(
    () =>
        import(
            "~components/modules/story-package/variants/3-up-deks/StoryPackage3UpDeks"
        ),
    { ssr: true }
);
export const StoryPackage4UpDeks = dynamic(
    () =>
        import(
            "~components/modules/story-package/variants/4-up-deks/StoryPackage4UpDeks"
        ),
    { ssr: true }
);
export const StoryPackage3UpHedsOnly = dynamic(
    () =>
        import(
            "~components/modules/story-package/variants/3-up-heds-only/StoryPackage3UpHedsOnly"
        ),
    { ssr: true }
);
export const StoryPackage3UpImages = dynamic(
    () =>
        import(
            "~components/modules/story-package/variants/3-up-images/StoryPackage3UpImages"
        ),
    { ssr: true }
);
export const StoryPackageSingleStoryColumns = dynamic(
    () =>
        import(
            "~components/modules/story-package/variants/single-story-columns/StoryPackageSingleStoryColumns"
        ),
    { ssr: true }
);
export const StoryPackage4UpImages = dynamic(
    () =>
        import(
            "~components/modules/story-package/variants/4-up-images/StoryPackage4UpImages"
        ),
    { ssr: true }
);
export const StoryPackage4UpHedsOnly = dynamic(
    () =>
        import(
            "~components/modules/story-package/variants/4-up-heds-only/StoryPackage4UpHedsOnly"
        ),
    { ssr: true }
);
export const StoryPackageOpinionHomepage = dynamic(
    () =>
        import(
            "~components/modules/story-package/variants/opinion-homepage/StoryPackageOpinionHomepage"
        ),
    { ssr: true }
);

export const StoryPackageOpinionAuthor = dynamic(
    () =>
        import(
            "~components/modules/story-package/variants/opinion-author/StoryPackageOpinionAuthor"
        ),
    { ssr: true }
);

/** ********** TODO: DEPRECATE - BEGIN ************/

export const StoryPackageNewOpinionHomepage = dynamic(
    () =>
        import(
            "~components/modules/story-package/variants/opinion-homepage/StoryPackageOpinionHomepage"
        ),
    { ssr: true }
);

/** ********** TODO: DEPRECATE - END ************/

export const StoryPackageSixUpImages = dynamic(
    () =>
        import(
            "~components/modules/story-package/variants/six-up-images/StoryPackageSixUpImages"
        ),
    { ssr: true }
);

export const NewsletterDefault = dynamic(
    () =>
        import(
            "~components/modules/newsletter/variants/default/NewsletterDefault"
        ),
    { ssr: true }
);
export const EmbedDefault = dynamic(
    () => import("~components/modules/embed/variants/default/EmbedDefault"),
    { ssr: true }
);
export const EmbedPodcastHighlight = dynamic(
    () =>
        import(
            "~components/modules/embed/variants/podcast-highlight/EmbedPodcastHighlight"
        ),
    { ssr: true }
);

// VIDEO
export const Video = dynamic(
    () => import("~components/modules/video/composer/Video"),
    {
        ssr: true,
    }
);
export const VideoDefault = dynamic(
    () => import("~components/modules/video/variants/default/VideoDefault"),
    { ssr: true }
);
export const VideoClimateChanged = dynamic(
    () =>
        import(
            "~components/modules/video/variants/climate-changed/VideoClimateChanged"
        ),
    { ssr: true }
);
export const VideoNewVoices = dynamic(
    () =>
        import("~components/modules/video/variants/new-voices/VideoNewVoices"),
    { ssr: true }
);

export const BannerRecircDefault = dynamic(
    () =>
        import(
            "~components/modules/banner-recirc/variants/default/BannerRecircDefault"
        ),
    { ssr: true }
);

export const StoryListLatestFiltered = dynamic(
    () =>
        import(
            "~components/modules/story-list/variants/latest-filtered/StoryListLatestFiltered"
        ),
    { ssr: true }
);

export const EmbedAudio = dynamic(
    () => import("~components/modules/embed/variants/audio/EmbedAudio"),
    { ssr: true }
);

export const PhoenixRelatedItems = dynamic(
    () => import("~components/shared/phoenix-related-items/PhoenixRelatedItems")
);

export const TickerPills = dynamic(
    () => import("~components/shared/ticker-pills/TickerPills"),
    { ssr: true }
);

export const TickerPill = dynamic(
    () => import("~components/shared/ticker-pill/TickerPill"),
    { ssr: true }
);

export const NewsletterPhoenix = dynamic(
    () =>
        import(
            "~components/modules/newsletter/variants/phoenix/NewsletterPhoenix"
        ),
    { ssr: true }
);

export const BreakingAdaptiveTabbedDisplay = dynamic(
    () =>
        import(
            "~components/shared/breaking-adaptive-tabbed-display/BreakingAdaptiveTabbedDisplay"
        ),
    { ssr: true }
);
export const MarketMover = dynamic(
    () => import("~components/shared/market-mover/MarketMover"),
    { ssr: true }
);

export const StoryListMarketMovers = dynamic(
    () =>
        import(
            "~components/modules/story-list/variants/market-movers/StoryListMarketMovers"
        ),
    { ssr: true }
);

export const MarketMovers = dynamic(
    () => import("~components/shared/market-movers/MarketMovers"),
    { ssr: true }
);

export const ErrorPrompt = dynamic(
    () => import("~components/shared/error-prompt/ErrorPrompt"),
    { ssr: true }
);

export const PulseDefault = dynamic(
    () => import("~components/modules/pulse/variants/default/PulseDefault"),
    { ssr: true }
);

export const PulseLinkList = dynamic(
    () => import("~components/modules/pulse/variants/link-list/PulseLinkList"),
    { ssr: true }
);

export const EmbedPodcastPlayer = dynamic(
    () =>
        import(
            "~components/modules/embed/variants/podcast-player/EmbedPodcastPlayer"
        ),
    { ssr: true }
);

export const LineupContentMagazineGrid = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/magazine-grid/LineupContentMagazineGrid"
        ),
    { ssr: true }
);

export const LineupContentArchive = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/archive/LineupContentArchive"
        ),
    { ssr: true }
);

export const SectionFrontHeaderImageTitle = dynamic(
    () =>
        import(
            "~components/modules/section-front-header/variants/image-title/SectionFrontHeaderImageTitle"
        ),
    { ssr: true }
);

export const LineupContentOpinion2Up = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/opinion-2-up/LineupContentOpinion2Up"
        ),
    { ssr: true }
);

export const LineupContentWeekendLandscape = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/weekend-landscape/LineupContentWeekendLandscape"
        ),
    { ssr: true }
);

export const SectionFrontHeaderLinkedImage = dynamic(
    () =>
        import(
            "~components/modules/section-front-header/variants/linked-image/SectionFrontHeaderLinkedImage"
        ),
    { ssr: true }
);

export const LineupContentWeekendPortrait = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/weekend-portrait/LineupContentWeekendPortrait"
        ),
    { ssr: true }
);

export const LineupContentArchiveFiltered = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/archive-filtered/LineupContentArchiveFiltered"
        ),
    { ssr: true }
);

export const StoryListUserWatchlist = dynamic(
    () =>
        import(
            "~components/modules/story-list/variants/user-watchlist/StoryListUserWatchlist"
        ),
    { ssr: true }
);

export const StoryListUserNewsletters = dynamic(
    () =>
        import(
            "~components/modules/story-list/variants/user-newsletters/StoryListUserNewsletters"
        ),
    { ssr: true }
);

export const UserTopicStories = dynamic(
    () =>
        import(
            "~components/modules/user-modules/variants/topic-stories/UserModulesTopicStories"
        ),
    { ssr: true }
);

export const LineupContentCarouselCards = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/carousel-cards/LineupContentCarouselCards"
        ),
    { ssr: true }
);

export const StoryListTrendingRecords = dynamic(
    () =>
        import(
            "~components/modules/story-list/variants/trending-records/StoryListTrendingRecords"
        ),
    { ssr: true }
);

export const LineupContentOpinion2UpVerticalXs = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/opinion-2-up-vertical-xs/LineupContentOpinion2UpVerticalXs"
        ),
    { ssr: true }
);

export const LineupContentAudio6Up = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/audio-6-up/LineupContentAudio6Up"
        ),
    { ssr: true }
);

export const LineupContentAudio8Up = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/audio-8-up/LineupContentAudio8Up"
        ),
    { ssr: true }
);

export const PulseAudioLinkList = dynamic(
    () =>
        import(
            "~components/modules/pulse/variants/audio-link-list/PulseAudioLinkList"
        ),
    { ssr: true }
);

export const LinksAudioAvailableOn = dynamic(
    () =>
        import(
            "~components/modules/links/variants/audio-available-on/LinksAudioAvailableOn"
        ),
    { ssr: true }
);

export const StoryListLiveRadioSchedule = dynamic(
    () =>
        import(
            "~components/modules/story-list/variants/live-radio-schedule/StoryListLiveRadioSchedule"
        ),
    { ssr: true }
);

export const LineupContentAudioPlayer = dynamic(
    () =>
        import(
            "~components/modules/lineup-content/variants/audio-player/LineupContentAudioPlayer"
        ),
    { ssr: true }
);

export const UserExplore = dynamic(
    () =>
        import(
            "~components/modules/user-modules/variants/explore/UserModulesExplore"
        ),
    { ssr: true }
);
